export const reportsForStore = [
    {label: 'Raport ogólny', value: 'archived_issues'},
    {label: 'Raport szczegółowy', value: 'detailed_issues'},
];

export const REPORT_TYPES = {
    general: 'archived_issues',
    detailed: 'detailed_issues',
};
